import axios from 'axios';
import { errorInterceptor, responseInterceptor } from './interceptors';
import { Environment } from '../../../environment';

const Api = axios.create({
    baseURL: Environment.URL_BASE,
    // headers: {
    //     Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token') || '')}`
    // }
});

const ApiBack = axios.create({
    baseURL: Environment.BACK_END_URL,
    // headers: {
    //     Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token') || '')}`
    // }
});

ApiBack.interceptors.response.use(
    (response) => responseInterceptor(response),
    (error) => errorInterceptor(error),
);

Api.interceptors.response.use(
    (response) => responseInterceptor(response),
    (error) => errorInterceptor(error),
);

export {Api, ApiBack};